import React from 'react';
import { AlertCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * FormError — renders an inline validation message under a field.
 *
 * Props:
 *   message    string | null — Arabic validation text (nothing renders when falsy)
 *   className  extra Tailwind classes
 *   id         optional id for aria-describedby wiring from the input
 */
export default function FormError({ message, className = '', id }) {
  if (!message) return null;
  return (
    <p
      id={id}
      role="alert"
      className={cn(
        'text-xs text-red-600 dark:text-red-400 mt-1 flex items-center gap-1',
        className
      )}
    >
      <AlertCircle size={12} aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}
